<template>
  <v-app-bar app color="primary" dark>
    <v-app-bar-nav-icon v-if="!back" @click="toggleAppbar"></v-app-bar-nav-icon>
    <v-app-bar-nav-icon v-else @click="$router.back()"
      ><v-icon> mdi-arrow-left</v-icon></v-app-bar-nav-icon
    >
    <v-toolbar-title color><slot name="title"></slot></v-toolbar-title>
    <slot name="content"></slot>
    <v-spacer></v-spacer>
    <slot name="fun-icons">
      <v-btn icon to="/search">
        <v-icon>mdi-magnify</v-icon>
      </v-btn>
    </slot>

    <template v-slot:extension v-if="showtab">
      <v-tabs align-with-title v-model="nowtab" grow>
        <v-tab v-for="item of tabs" :key="item.title">
          {{ item.title }}
        </v-tab>
        <v-tabs-slider color="pink"></v-tabs-slider>
      </v-tabs>
    </template>
  </v-app-bar>

</template>

<script>
export default {
  name: "AppBar",
  props: {
    back: {
      type: Boolean,
      default: function() {
        return false;
      }
    },
    tabs: {
      type: Array,
      default: function() {
        return [];
      },
      tab: {
        type: Number,
        default: function() {
          return 1;
        }
      }
    },
    showtab: {
      type: Boolean,
      default: function() {
        return true;
      }
    }
  },
  computed: {
    nowtab: {
      get() {
        return this.$attrs.tab;
      },
      set(val) {
        this.$emit("update:tab", val);
      }
    }
  },
  methods: {
    toggleAppbar() {
      if (this.$store.state.leftbar.drawer) {
        this.$store.commit("toggleLeftBar", false);
      } else {
        this.$store.commit("toggleLeftBar", true);
      }
    },
    click: function(link) {
      if (this.$route.path !== link && link) {
        this.$router.push(link);
      }
    }
  }
};
</script>
<style></style>
